<svg:g *ngIf="serie.isVisible">
    <svg:g *ngFor="let circle of serie.dataPoints; trackBy: keyAccessor">
        <svg:circle *ngIf="this.serie.drawNullPoint || this.serie.yAccessor(circle)"
                    [style.stroke]="serie.config.color"
                    [attr.cx]="serie.xAccessorScaled(circle)"
                    [attr.cy]="serie.yAccessorScaled(circle)"
                    [attr.r]="radius">
            <!-- <animate
            attributeName="cy"
            attributeType="XML"
            [attr.from]="serie.y0AccessorScaled(circle)"
            [attr.to]="serie.yAccessorScaled(circle)"
            begin="0s"
            dur="1s"
            fill="freeze"
        /> -->
        </svg:circle>
    </svg:g>
</svg:g>
